import { ThemeOptions } from '@mui/material';

import colors from './colors';

const palette: ThemeOptions['palette'] = {
  primary: {
    main: colors.graytone950,
    contrastText: colors.graytone50,
  },
  secondary: {
    main: colors.graytone50,
    contrastText: colors.graytone950,
  },
  error: {
    main: colors.orange950,
    contrastText: colors.orange500,
  },
  warning: {
    main: colors.orange300,
  },
  success: {
    main: colors.green500,
  },
  info: {
    main: colors.blue500,
  },
};

export default palette;
